(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-related-products-wrap]').forEach(function (wrap) {
      var listEl = wrap.querySelector('.product-grid');
      var prev = wrap.querySelector('[data-related-products-prev]');
      var next = wrap.querySelector('[data-related-products-next]');
      if (!listEl || !prev || !next) return;

      function scrollByCard(dir) {
        var card = listEl.querySelector('.grid__item');
        var gap = parseInt(window.getComputedStyle(listEl).columnGap, 10) || 16;
        var amount = card ? card.getBoundingClientRect().width + gap : 240;
        listEl.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      function updateDisabled() {
        prev.disabled = listEl.scrollLeft <= 0;
        next.disabled = listEl.scrollLeft + listEl.clientWidth >= listEl.scrollWidth - 1;
      }

      prev.addEventListener('click', function () {
        scrollByCard(-1);
      });
      next.addEventListener('click', function () {
        scrollByCard(1);
      });
      listEl.addEventListener('scroll', updateDisabled);
      updateDisabled();
    });
  });
})();
